import React, { Component, Fragment } from "react";
import styled from "styled-components";
import * as Widget from "../Widget";
import * as Icon from "../Icon";
import AppConfig from "../../Config";

const themeColor = AppConfig.global.themeColor;

const Wrapper = styled.div`
  ${props => props.css}
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  height: 30px;

  & > a {
    font-size: 14px;
    color: ${props => (props.selected ? "#16233D" : themeColor)};
    cursor: pointer;
  }

  & > .expand {
    background: transparent;
    cursor: pointer;
    height: 24px;
    padding-left: 10px;
  }
`;

class TreeNodeWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expand: this._shouldExpand()
    };
  }

  render() {
    let { node, onNodeClick, activeNode, css = "" } = this.props;
    const { expand } = this.state;
    const hasChildren = node.children && node.children.length > 0;
    const selected = activeNode === node.name;

    return (
      <Wrapper css={css}>
        {node.name === "root" ? null : (
          <FilterRow selected={selected}>
            <a onClick={() => onNodeClick(node.name)}>
              {node.display || node.name}
            </a>

            {hasChildren && (
              <div
                className="expand"
                onClick={() => this.setState({ expand: !expand })}
              >
                {expand ? (
                  <Icon.KeyboardArrowDown size={20} color={themeColor} />
                ) : (
                  <Icon.KeyboardArrowUp size={20} color={themeColor} />
                )}
              </div>
            )}
          </FilterRow>
        )}

        {this._renderChildren()}
      </Wrapper>
    );
  }

  _renderChildren = () => {
    let { node, onNodeClick, activeNode } = this.props;
    const { expand } = this.state;
    const hasChildren = node.children && node.children.length > 0;

    if (!expand || !hasChildren) {
      return null;
    }

    return node.children.map((c, idx) => (
      <TreeNodeWrapper
        key={c.name}
        activeNode={activeNode}
        onNodeClick={onNodeClick}
        css={
          node.name === "root"
            ? ""
            : `padding-left: 10px; 
          margin-left: 10px;
          border-left: solid 1px ${themeColor};`
        }
        node={c}
      />
    ));
  };

  _shouldExpand = () => {
    let { node, activeNode } = this.props;
    return activeNode.indexOf(node.name) === 0 && node.name !== activeNode;
  };
}

export default TreeNodeWrapper;
